var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41201 9.5316H4L4 8H8.38839V9.5316H6.97608V14H5.41201V9.5316ZM8.63123 8H12.8982V9.5316H10.1954V10.2704H12.8982V11.7116H10.1954V12.4684H12.8982V14H8.63123V8ZM13.1562 8H15.7224C17.408 8 18 9.47755 18 10.9911C18 12.8289 17.1799 14 15.4186 14H13.1562V8ZM14.7204 12.4684H15.3275C16.2993 12.4684 16.4362 11.5316 16.4362 10.9731C16.4362 10.5946 16.3299 9.54963 15.206 9.54963H14.7048L14.7204 12.4684Z",
    fill: "#E62B1E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTed);
export default __webpack_public_path__ + "static/media/Ted.667183f4e49808c6394bb0d0432dce40.svg";
export { ForwardRef as ReactComponent };